module.exports = __webpack_public_path__ + "img/mathias-de-sousa.fe62cc58.png";